export default function Footer() {
  return (
    <footer className="mt-16 border-t hairline">
      <div className="mx-auto max-w-6xl px-6 py-12 text-sm text-ink-dim flex flex-wrap justify-between gap-6">
        <p>SHIFT — May 2026. An opinionated field guide.</p>
        <p>
          This site is agent-readable: see{' '}
          <a className="text-accent underline" href="/llms.txt">
            /llms.txt
          </a>{' '}
          and{' '}
          <a className="text-accent underline" href="/llms-full.txt">
            /llms-full.txt
          </a>
          .
        </p>
      </div>
    </footer>
  );
}
